<template lang="pug">
.strongest-leaderboard
  client-only
    RoguePointsLeaderboard(:compId="compId" :defaultDivision="defaultDivision" :filterOptionsYears="filterOptionsYears" :filtersOpenByDefault="mq !== 'mobile' && mq !== 'tablet'" :apiBaseUrl="strongestBaseUrl")
</template>
<script setup lang="ts">
import { RoguePointsLeaderboard } from '@rogue/vue-strongest-leaderboard'
import { useMQ } from 'sisu/js/mq'
import { useRogue } from '@/js/services/Rogue'
import '@rogue/vue-strongest-leaderboard/dist/style.css'

const rogue = useRogue()
const mq = useMQ()

const strongestBaseUrl = rogue.keys?.strongest?.baseUrl || 'https://compete-strongest-com.global.ssl.fastly.net/api/p/'

withDefaults(
  defineProps<{
    compId?: string,
    defaultDivision?: string,
    filterOptionsYears?: any[]
  }>(), {
    compId             : 'rogue-points',
    defaultDivision    : 'Women',
    filterOptionsYears : (() => []),
  }
)

</script>
